// Utility to calculate streak for both flat and nested log structures
export function calculateStreak(log, type = "general") {
  if (!log || typeof log !== "object") return 0;

  // Get all logged dates (YYYY-MM-DD)
  const datesWithLogs = Object.values(log)
    .map((entry) => {
      // If entry has a 'date' field and 'entries' (nested structure)
      if (entry && entry.date && entry.entries) {
        const hasMealWithTimestamp = Object.values(entry.entries).some(
          (meal) => meal && meal.Timestamp
        );
        return hasMealWithTimestamp ? entry.date : null;
      }
      // Flat structure: look for Timestamp at top level
      if (entry && entry.Timestamp) {
        const d = new Date(entry.Timestamp);
        return (
          d.getFullYear() +
          "-" +
          String(d.getMonth() + 1).padStart(2, "0") +
          "-" +
          String(d.getDate()).padStart(2, "0")
        );
      }
      return null;
    })
    .filter(Boolean);

  // For hydration, also check if all 3 cues were completed
  if (type === "hydration") {
    const datesWithCompleteHydration = Object.values(log)
      .map((entry) => {
        if (
          entry &&
          entry.date &&
          entry.completedCues &&
          entry.completedCues.length === 3
        ) {
          return entry.date;
        }
        return null;
      })
      .filter(Boolean);

    // Use the more restrictive condition (complete hydration)
    const dateSet = new Set(datesWithCompleteHydration);
    let streak = 0;
    let current = new Date();
    for (;;) {
      const dateStr =
        current.getFullYear() +
        "-" +
        String(current.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(current.getDate()).padStart(2, "0");
      if (dateSet.has(dateStr)) {
        streak++;
        current.setDate(current.getDate() - 1);
      } else {
        if (streak === 0) {
          current.setDate(current.getDate() - 1);
          const yestStr =
            current.getFullYear() +
            "-" +
            String(current.getMonth() + 1).padStart(2, "0") +
            "-" +
            String(current.getDate()).padStart(2, "0");
          if (dateSet.has(yestStr)) {
            streak++;
            continue;
          }
        }
        break;
      }
    }
    return streak;
  }

  // For sleep, check if any sleep cues were completed
  if (type === "sleep") {
    const datesWithSleepLogged = Object.values(log)
      .map((entry) => {
        if (
          entry &&
          entry.date &&
          entry.completedCues &&
          entry.completedCues.length > 0
        ) {
          return entry.date;
        }
        return null;
      })
      .filter(Boolean);

    const dateSet = new Set(datesWithSleepLogged);
    let streak = 0;
    let current = new Date();
    for (;;) {
      const dateStr =
        current.getFullYear() +
        "-" +
        String(current.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(current.getDate()).padStart(2, "0");
      if (dateSet.has(dateStr)) {
        streak++;
        current.setDate(current.getDate() - 1);
      } else {
        if (streak === 0) {
          current.setDate(current.getDate() - 1);
          const yestStr =
            current.getFullYear() +
            "-" +
            String(current.getMonth() + 1).padStart(2, "0") +
            "-" +
            String(current.getDate()).padStart(2, "0");
          if (dateSet.has(yestStr)) {
            streak++;
            continue;
          }
        }
        break;
      }
    }
    return streak;
  }

  const dateSet = new Set(datesWithLogs);
  let streak = 0;
  let current = new Date();
  for (;;) {
    const dateStr =
      current.getFullYear() +
      "-" +
      String(current.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(current.getDate()).padStart(2, "0");
    if (dateSet.has(dateStr)) {
      streak++;
      current.setDate(current.getDate() - 1);
    } else {
      if (streak === 0) {
        current.setDate(current.getDate() - 1);
        const yestStr =
          current.getFullYear() +
          "-" +
          String(current.getMonth() + 1).padStart(2, "0") +
          "-" +
          String(current.getDate()).padStart(2, "0");
        if (dateSet.has(yestStr)) {
          streak++;
          continue;
        }
      }
      break;
    }
  }
  return streak;
}
